<template>
  <div class="space-y-5 pt-32 font-heiti">
    <div class="text-blue-level mb-16 text-center mx-auto text-2xl">目录</div>
    <div class="flex flex-nowrap">
      <div class="">一、评测结论</div>
      <div class="flex-1 overflow-hidden flex flex-nowrap">{{repeatDots}}</div>
      <div>1</div>
    </div>
    <div class="flex flex-nowrap">
      <div class="">二、各维度评测分析</div>
      <div class="flex-1 overflow-hidden flex flex-nowrap">{{repeatDots}}</div>
      <div>2</div>
    </div>
    <div class="flex flex-nowrap">
      <div style="text-indent: 2rem;" class="font-kaiti text-bold">（一）数字化基础、数字化管理、数字化成效三个维度</div>
      <div class="flex-1 overflow-hidden flex flex-nowrap">{{repeatDots}}</div>
      <div>2</div>
    </div>
    <div class="flex flex-nowrap">
      <div style="text-indent: 4rem;">【总览】评测指标体系及评测得分</div>
      <div class="flex-1 overflow-hidden flex flex-nowrap">{{repeatDots}}</div>
      <div>2</div>
    </div>
    <div class="flex flex-nowrap">
      <div style="text-indent: 4rem;">【A】数字化基础维度</div>
      <div class="flex-1 overflow-hidden flex flex-nowrap">{{repeatDots}}</div>
      <div>4</div>
    </div>
    <div class="flex flex-nowrap">
      <div style="text-indent: 4rem;">【B】数字化管理维度</div>
      <div class="flex-1 overflow-hidden flex flex-nowrap">{{repeatDots}}</div>
      <div>6</div>
    </div>
    <div class="flex flex-nowrap">
      <div style="text-indent: 4rem;">【C】数字化成效维度</div>
      <div class="flex-1 overflow-hidden flex flex-nowrap">{{repeatDots}}</div>
      <div>8</div>
    </div>
    <div class="flex flex-nowrap">
      <div style="text-indent: 2rem;" class="font-kaiti text-bold">（二）数字化经营维度</div>
      <div class="flex-1 overflow-hidden flex flex-nowrap">{{repeatDots}}</div>
      <div>10</div>
    </div>
    <div class="flex flex-nowrap">
      <div style="text-indent: 4rem;">【总览】评测指标体系及应用场景等级判定</div>
      <div class="flex-1 overflow-hidden flex flex-nowrap">{{repeatDots}}</div>
      <div>10</div>
    </div>
    <div class="flex flex-nowrap">
      <div style="text-indent: 4rem;">【D】产品生命周期数字化</div>
      <div class="flex-1 overflow-hidden flex flex-nowrap">{{repeatDots}}</div>
      <div>12</div>
    </div>
    <div class="flex flex-nowrap">
      <div style="text-indent: 4rem;">【E】生产执行数字化</div>
      <div class="flex-1 overflow-hidden flex flex-nowrap">{{repeatDots}}</div>
      <div>13</div>
    </div>
    <div class="flex flex-nowrap">
      <div style="text-indent: 4rem;">【F】供应链数字化</div>
      <div class="flex-1 overflow-hidden flex flex-nowrap">{{repeatDots}}</div>
      <div>15</div>
    </div>
    <div class="flex flex-nowrap">
      <div style="text-indent: 4rem;">【G】管理决策数字化</div>
      <div class="flex-1 overflow-hidden flex flex-nowrap">{{repeatDots}}</div>
      <div>16</div>
    </div>
    <div class="flex flex-nowrap">
      <div class="">评测机构签署页</div>
      <div class="flex-1 overflow-hidden flex flex-nowrap">{{repeatDots}}</div>
      <div>17</div>
    </div>
  </div>
</template>

<script>
// 目录
export default {
  props: ['info'],
  data () {
    return {
      repeatDots: Array(1000).fill('.').join('')
    }
  }
}
</script>
